export default __webpack_public_path__ + "static/media/the_chicago_dog.8850ffe7.jpg";